// extracted by css-extract-rspack-plugin
export default {"counterSkeleton":"CounterSkeleton-module__counterSkeleton__KoRtL"};